document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');
const products = new Map();

function initializeProduct(section) {
  if (products.has(section)) return;
  const controller = new AbortController();
  const on = (element, type, callback) => element?.addEventListener(type, callback, { signal: controller.signal });
  const gallery = section.querySelector('[data-gallery]');
  const thumbnails = [...section.querySelectorAll('[data-gallery-index]')];
  const frames = gallery ? [...gallery.children] : [];
  const scrollToFrame = (index) => {
    const frame = frames[index];
    if (!frame) return;
    gallery.scrollTo({ left: frame.offsetLeft - frames[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  };
  thumbnails.forEach((button) => on(button, 'click', () => scrollToFrame(Number(button.dataset.galleryIndex))));
  on(gallery, 'scroll', () => {
    const index = frames.reduce((best, frame, i) => Math.abs(frame.offsetLeft - frames[0].offsetLeft - gallery.scrollLeft) < Math.abs(frames[best].offsetLeft - frames[0].offsetLeft - gallery.scrollLeft) ? i : best, 0);
    thumbnails.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
    frames.forEach((frame, i) => { if (i !== index) frame.querySelectorAll('video').forEach((video) => video.pause()); });
  });
  on(gallery, 'keydown', (event) => {
    if (event.target !== gallery || !['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
    event.preventDefault();
    const index = thumbnails.findIndex((button) => button.getAttribute('aria-current') === 'true');
    scrollToFrame(Math.max(0, Math.min(frames.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1))));
  });
  const dialog = section.querySelector('[data-zoom-dialog]');
  section.querySelectorAll('[data-zoom-src]').forEach((button) => on(button, 'click', () => {
    const image = dialog.querySelector('[data-zoom-image]');
    image.src = button.dataset.zoomSrc;
    image.alt = button.dataset.zoomAlt;
    dialog.showModal();
  }));
  on(section.querySelector('[data-zoom-close]'), 'click', () => dialog.close());
  on(dialog, 'click', (event) => { if (event.target === dialog) dialog.close(); });
  const selector = section.querySelector('select[name="id"]');
  const button = section.querySelector('[data-add-button]');
  const sticky = section.querySelector('[data-sticky-cta]');
  const stickyButton = section.querySelector('[data-sticky-button]');
  const appZone = section.querySelector('.product-app-zone');
  const target = appZone || button;
  let targetVisible = true;
  const mobile = window.matchMedia('(max-width: 989px)');
  const showSticky = () => {
    if (!sticky) return;
    const enabled = Boolean(target) && !targetVisible && mobile.matches;
    sticky.hidden = !enabled;
    document.body.classList.toggle('has-sticky-cta', enabled);
  };
  const update = (changeMedia = false) => {
    const option = selector?.selectedOptions[0];
    if (option) {
      const available = option.dataset.available === 'true';
      const price = section.querySelector('[data-price]:not(option)');
      const compare = section.querySelector('[data-compare]:not(option)');
      const saving = section.querySelector('[data-saving]:not(option)');
      if (price) price.textContent = option.dataset.price;
      if (compare) { compare.textContent = option.dataset.compare; compare.hidden = option.dataset.sale !== 'true'; }
      if (saving) { saving.textContent = option.dataset.saving; saving.hidden = option.dataset.sale !== 'true'; }
      if (button) { button.disabled = !available; button.textContent = available ? 'Agregar al carrito' : 'Agotado'; }
      const status = section.querySelector('[data-product-status]');
      if (status) status.textContent = available ? '' : 'Esta variante está agotada.';
      const stickyPrice = section.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = option.dataset.price;
      if (stickyButton && !appZone) stickyButton.disabled = !available;
      if (changeMedia && option.dataset.mediaId) scrollToFrame(frames.findIndex((frame) => frame.dataset.mediaId === option.dataset.mediaId));
      if (!window.Shopify?.designMode) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
    } else if (stickyButton && button && !appZone) stickyButton.disabled = button.disabled;
  };
  on(selector, 'change', () => update(true));
  on(section.querySelector('.product-form'), 'submit', (event) => {
    if (section.hasAttribute('data-cod-only')) { event.preventDefault(); return; }
    if (selector && selector.selectedOptions[0]?.dataset.available !== 'true') { event.preventDefault(); update(); }
  });
  if (selector && section.querySelector('[data-pack-variant]')) selector.tabIndex = -1;
  section.querySelectorAll('[data-pack-variant]').forEach((radio) => on(radio, 'change', () => {
    if (!selector) return;
    selector.value = radio.value;
    selector.dispatchEvent(new Event('change', {bubbles:true}));
  }));
  on(selector, 'change', () => section.querySelectorAll('[data-pack-variant]').forEach((radio) => { radio.checked = radio.value === selector.value; }));
  const quantity = section.querySelector('input[name="quantity"]');
  section.querySelectorAll('[data-bundle-quantity]').forEach((radio) => on(radio, 'change', () => {
    quantity.value = radio.value;
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  on(quantity, 'change', () => section.querySelectorAll('[data-bundle-quantity]').forEach((radio) => { radio.checked = radio.value === quantity.value; }));
  on(stickyButton, 'click', () => {
    target?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    const focusTarget = appZone?.querySelector('button,a,input') || button;
    focusTarget?.focus({ preventScroll: true });
  });
  const observer = target && sticky ? new IntersectionObserver(([entry]) => { targetVisible = entry.isIntersecting; showSticky(); }) : null;
  if (observer) observer.observe(target);
  mobile.addEventListener('change', showSticky, { signal: controller.signal });
  update();
  products.set(section, () => { controller.abort(); observer?.disconnect(); document.body.classList.remove('has-sticky-cta'); });
}

function initializeDrawer(drawer) {
  if (drawer.dataset.initialized) return;
  drawer.dataset.initialized = 'true';
  const summary = drawer.querySelector(':scope > summary');
  const panel = drawer.querySelector('nav');
  const close = () => { drawer.open = false; summary.focus(); };
  drawer.querySelectorAll('[data-drawer-close]').forEach((element) => element.addEventListener('click', close));
  drawer.addEventListener('toggle', () => {
    document.body.style.overflow = drawer.open ? 'hidden' : '';
    summary.setAttribute('aria-expanded', String(drawer.open));
    if (drawer.open) panel.querySelector('button,a')?.focus();
  });
  drawer.addEventListener('keydown', (event) => {
    if (!drawer.open) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key === 'Tab') {
      const focusable = [...panel.querySelectorAll('a,button,summary,input')].filter((el) => el.getClientRects().length);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
}

function initialize(root = document) {
  root.querySelectorAll('[data-product-section]').forEach(initializeProduct);
  root.querySelectorAll('[data-drawer]').forEach(initializeDrawer);
}
initialize();
document.addEventListener('shopify:section:load', (event) => initialize(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-product-section]').forEach((section) => { products.get(section)?.(); products.delete(section); });
  if (event.target.querySelector('[data-drawer]')) document.body.style.overflow = '';
});
const sliders = new WeakMap();
function initializeSlider(section) {
  if (sliders.has(section)) return;
  const controller = new AbortController();
  const track = section.querySelector('[data-slide-track]');
  const slides = [...section.querySelectorAll('[data-home-slide]')];
  const dots = [...section.querySelectorAll('[data-slide-to]')];
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let index = 0;
  let frame = 0;
  const sync = () => {
    index = Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth));
    dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
    slides.forEach((slide, i) => { slide.inert = i !== index; });
    const status = section.querySelector('[data-slide-status]');
    if (status) status.textContent = `Diapositiva ${index + 1} de ${slides.length}`;
  };
  const go = (next) => {
    const target = (next + slides.length) % slides.length;
    track.scrollTo({left: target * track.clientWidth, behavior: reduced() ? 'instant' : 'smooth'});
  };
  const on = (target, event, callback) => target?.addEventListener(event, callback, {signal: controller.signal});
  on(section.querySelector('[data-slide-prev]'), 'click', () => go(index - 1));
  on(section.querySelector('[data-slide-next]'), 'click', () => go(index + 1));
  dots.forEach((dot, i) => on(dot, 'click', () => go(i)));
  on(track, 'scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); });
  on(track, 'keydown', (event) => {
    if (event.target !== track) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();go(index + (event.key === 'ArrowRight' ? 1 : -1));}
  });
  const resize = new ResizeObserver(() => track.scrollTo({left: index * track.clientWidth, behavior:'instant'}));
  resize.observe(track);
  sync();
  sliders.set(section, () => {controller.abort();resize.disconnect();cancelAnimationFrame(frame);});
}
let motionObserver;
function initializeMotion(root = document) {
  root.querySelectorAll('[data-home-slider]').forEach(initializeSlider);
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  motionObserver ||= new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) {entry.target.classList.add('is-visible');motionObserver.unobserve(entry.target);}
  }), {threshold:0.08});
  root.querySelectorAll('.category-card,.benefit-card,.editorial-copy,.editorial-media,.section-heading,.pack-choice').forEach((element, index) => {
    if (element.classList.contains('reveal-ready')) return;
    element.style.setProperty('--reveal-delay', `${Math.min(index % 3, 2) * 60}ms`);
    element.classList.add('reveal-ready');motionObserver.observe(element);
  });

}
initializeMotion();
document.addEventListener('shopify:section:load', (event) => initializeMotion(event.target));
document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target.querySelector?.('[data-home-slide]');
  const track = slide?.closest('[data-slide-track]');
  if (track) {
    const index = [...track.querySelectorAll('[data-home-slide]')].indexOf(slide);
    track.scrollTo({left: index * track.clientWidth, behavior:'instant'});
  }
});
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-home-slider]').forEach((section) => {sliders.get(section)?.();sliders.delete(section);});
  event.target.querySelectorAll('.reveal-ready').forEach((element) => motionObserver?.unobserve(element));
});

const offerClocks = new WeakMap();
function initializeOfferClocks(root = document) {
  root.querySelectorAll('[data-offer-clock]').forEach((clock) => {
    if (offerClocks.has(clock)) return;
    const deadline = Date.parse(clock.dataset.offerClock);
    if (!Number.isFinite(deadline) || !/(Z|[+-]\d{2}:\d{2})$/.test(clock.dataset.offerClock)) return;
    const date = clock.querySelector('[data-offer-date]');
    date.textContent = 'Hasta ' + new Intl.DateTimeFormat('es-CL', {timeZone:'America/Santiago', day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit', hour12:false}).format(deadline) + ' h de Chile';
    const update = () => {
      const remaining = Math.ceil((deadline - Date.now()) / 1000);
      clock.hidden = remaining <= 0;
      if (remaining <= 0) { clearInterval(offerClocks.get(clock)); return; }
      const hours = Math.floor(remaining / 3600), minutes = Math.floor(remaining % 3600 / 60), seconds = remaining % 60;
      clock.querySelector('[data-offer-time]').textContent = [hours, minutes, seconds].map(v => String(v).padStart(2, '0')).join(' : ');
    };
    offerClocks.set(clock, setInterval(update, 1000)); update();
  });
}
initializeOfferClocks();
const productMotion = new WeakMap();
function initializeProductMotion(root = document) {
  root.querySelectorAll('[data-product-motion]').forEach(section => {
    if (productMotion.has(section)) return;
    const controller = new AbortController();
    const button = section.querySelector('[data-motion-pause]');
    button.addEventListener('click', () => {
      const paused = section.classList.toggle('is-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? 'Reanudar animaciones' : 'Pausar animaciones';
    }, {signal:controller.signal});
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => section.classList.toggle('is-offscreen', !entry.isIntersecting))) : null;
    observer?.observe(section);
    productMotion.set(section, () => {controller.abort();observer?.disconnect();});
  });
}
initializeProductMotion();
const imageSliders = new WeakMap();
function initializeImageSliders(root = document) {
  root.querySelectorAll('[data-product-image-slider]').forEach(section => {
    if (imageSliders.has(section)) return;
    const controller = new AbortController();
    const track = section.querySelector('[data-image-track]');
    const prev = section.querySelector('[data-image-prev]');
    const next = section.querySelector('[data-image-next]');
    const update = () => {prev.disabled = track.scrollLeft < 2;next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;};
    const go = direction => track.scrollBy({left:direction * (track.firstElementChild.getBoundingClientRect().width + 16),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
    prev.addEventListener('click',()=>go(-1),{signal:controller.signal});
    next.addEventListener('click',()=>go(1),{signal:controller.signal});
    track.addEventListener('scroll',update,{signal:controller.signal,passive:true});
    track.addEventListener('keydown',event=>{if(event.target === track && ['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();go(event.key === 'ArrowRight' ? 1 : -1);}},{signal:controller.signal});
    const observer = new ResizeObserver(update);observer.observe(track);update();
    imageSliders.set(section,()=>{controller.abort();observer.disconnect();});
  });
}
initializeImageSliders();
document.addEventListener('shopify:section:load',event=>initializeImageSliders(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-product-image-slider]').forEach(section=>{imageSliders.get(section)?.();imageSliders.delete(section);}));
document.addEventListener('shopify:section:load', event => initializeProductMotion(event.target));
document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-product-motion]').forEach(section => {productMotion.get(section)?.();productMotion.delete(section);}));
document.addEventListener('shopify:section:load', event => initializeOfferClocks(event.target));
document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-offer-clock]').forEach(clock => {clearInterval(offerClocks.get(clock));offerClocks.delete(clock);}));
